import { createFileRoute } from "@tanstack/react-router";
import { usersListSearchSchema } from "@/features/admin/users/_configs/users-list-search-schema";
import { ManagersList } from "@/features/admin/users/list/managers-list";

export const Route = createFileRoute("/admin/users/managers")({
  validateSearch: usersListSearchSchema,
  component: ManagersList,
});
